import ScrollTo from './ScrollTo'

export default ScrollTo
// eslint-disable-next-line import/export
export * from './ScrollTo'
